<template>
  <div>
    <!-- Mensagem de erro ou sucesso -->
    <transition name="zoom">
      <div v-if="showError" class="error-message fs-1" @click="closeMessage">
        <div>
          <span class="fs-1 amarelo">{{ message }}</span>
        </div>
        <div>
          <!-- Botão OK abaixo do texto -->
          <button class="btnx mt-4" @click="closeMessage">OK</button>
        </div>
      </div>
    </transition>

    <div class="hero2">
      <div class="row">
        <div class="col-12 div-newsletter">
          <div class="fs-1" style="max-width:60rem">
            Sign up to stay informed about our launch updates.<br><br>
            <input 
              v-model="email" 
              type="email" 
              class="inputx amarelo f-6" 
              placeholder="your email"
            >
            <br>
            <button class="btnx mt-4" @click="sendEmail">SEND</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '', // Email do usuário
      showError: false, // Controle para mostrar a mensagem de erro
      message: "Please enter your email!", // Mensagem de erro ou sucesso
    };
  },
  methods: {
    // Função de validação de email usando regex
    isValidEmail(email) {
      const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return regex.test(email);
    },

    async sendEmail() {
      // Verifique se o email está vazio
      if (!this.email) {
        this.showError = true;
        this.message = "Please enter your email!";
        return;
      }

      // Verifique se o email é válido
      if (!this.isValidEmail(this.email)) {
        this.showError = true;
        this.message = "Please enter a valid email!";
        return;
      }

      try {
        // Enviar o email via POST para o servidor
        const response = await fetch('http://post.com/email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: this.email }), // Envia o email como JSON
        });

        const data = await response.json();

        if (data.success === 1) {
          // Se o POST for bem-sucedido, exibe a mensagem de sucesso
          this.message = "Obrigado por se cadastrar!";
        } else {
          // Caso o POST não seja bem-sucedido
          this.message = "Error sending email.";
        }

        this.showError = true; // Exibe a mensagem
      } catch (error) {
        console.error('Error:', error);
        this.message = "An error occurred. Please try again.";
        this.showError = true; // Exibe a mensagem de erro
      }
    },

    closeMessage() {
      // Fecha a mensagem com animação de zoom-out e fade-out
      this.showError = false;
    },
  },
};
</script>

<style scoped>
:root {
  --cream: #E0D0A6;
  --blue: #6FD0E7;
  --blue2: #83DEF4;
  --green: #536D3F;
  --mid-green: #475C37;
  --dark-green: #3D4D31;
  --object-sans: 'Object Sans', Arial, Helvetica, sans-serif;
}

.bg-verde-esc {
  background-color: var(--dark-green);
}

.amarelo {
  color: var(--cream);
}

.left {
  text-align: left;
}

.border-null {
  border: 1px solid var(--mid-green);
}

.hero2 {
  position: relative;
  height: 100vh;
  background: url('@/assets/bg01.jpg') no-repeat center center/cover;
}

/* Mensagem de erro ou sucesso com animação de zoom-in */
.error-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Centraliza a mensagem */
  width: 70%;
  height: 70%; /* Deixa a altura ajustável */
  background-color: rgba(83, 109, 63, 0.96); /* Fundo com 90% de opacidade */
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  z-index: 9999;
  animation: zoomIn 0.5s ease-out;
  flex-direction: column; /* Organiza o conteúdo em coluna */
  padding: 2rem;
}

/* Animação de zoom-in */
@keyframes zoomIn {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0; /* Inicia invisível */
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1; /* Fica completamente visível */
  }
}

/* Transição de zoom-out com fade-out (diminuição da opacidade) */
.zoom-leave-active {
  animation: zoomOut 0.5s ease-in-out;
}

@keyframes zoomOut {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1; /* Totalmente visível no início */
  }
  100% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0; /* A opacidade vai para 0 no final da animação */
  }
}

/* SE FOR NA TELA DE CELULAR PEQUENA */
@media screen and (max-width: 640px) {
  .hero2 {
    z-index: 1;
    position: relative;
    height: 100vh;
    background-color: var(--mid-green); /* Mantém o fundo verde */
    background-image: none; /* Remove a imagem de fundo */
  }

  .border-log {
    border: 4px solid rgb(0, 0, 255);
  }

  .content {
    padding: 2rem;
    margin: 2rem;
    text-align: left;
  }

  .row {
    flex-direction: column;
    text-align: center;
  }

  .col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .col-4 {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 4rem;
  }

  .p-10 {
    padding: 2rem;
  }
}

/* SE FOR NA TELA GRANDE */
@media screen and (min-width: 641px) {
  .border-log {
    border: 4px solid red;
  }

  .p-10 {
    padding: 8rem;
  }
}
</style>
